<script>
export default {
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {
    orderedPlans: function () {
      return Object.values(this.component.plans).sort(function (a, b) {
        return parseInt(a.weight) - parseInt(b.weight);
      });
    },
  },
  mounted: function () {
    console.log("PlanTunnelChoose mounted", this, this.component);
  },
};
</script>

<template>
  <div class="plan-tunnel-choose-component">
    <div class="main-title">{{ $vt("Choose a plan") }}</div>
    <div class="plans">
      <component
        @upgrade="$emit('upgrade', $event)"
        v-for="plan in orderedPlans"
        :key="plan['#id']"
        v-bind:is="plan.meta.type"
        :component="plan"
        :handler="handler"
      >
      </component>
    </div>
    <f-link
      class="conditions"
      blank
      href="https://www.vodalys.io/en/general-terms-of-service/"
      >{{ $vt("General Conditions of Use") }}</f-link>
  </div>
</template>

<style lang="scss">
.plan-tunnel-choose-component {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;
  .plans {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 32px;
  }
  .f-link.conditions {
    color: var(--white-a75);
    text-align: center;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 125%; /* 15px */
    align-self: center;
  }
}
</style>